<template>
	<div :class="['c-dashboard', { bg: hasBackground }]">
		<!-- <Header></Header> -->
		<Breadcrumbs :currentBlock="currentBlock" v-if="currentBlock"></Breadcrumbs>
		<SheetView :blockId="blockId"></SheetView>
		<!-- <Export></Export> -->
		<!-- <Window v-if="mode !== 'iframe'"></Window> -->
		<!-- <FilePicker></FilePicker> -->
	</div>
</template>

<script>
import Breadcrumbs from '@/components/dashboard/breadcrumbs';
import Header from '@/components/dashboard/header';
import SheetView from '@/components/dashboard/sheet-view';
import Export from '@/components/dashboard/export';
import FilePicker from '@/components/dashboard/file-picker';

export default {
	components: {
		//Window,
		Breadcrumbs,
		Header,
		SheetView,
		Export,
		FilePicker,
	},

	data: function () {
		return {
			options: {},
		};
	},

	watch: {
		blockId: {
			handler: function () {
				if (!this.$store.state.loaded) {
					return;
				}
				if (!this.blockId) {
					let rootBlock = this.$store.getters['block/rootBlock'];
					this.$store.dispatch('dashboard/setCurrentBlock', rootBlock._id);
					return;
				}

				let block = this.$store.getters['block/block'](this.blockId);

				if (!block) {
					// means its a 404
					let rootBlock = this.$store.getters['block/rootBlock'];
					this.$store.dispatch('dashboard/setCurrentBlock', rootBlock._id);

					this.$router.push({
						path: `/`,
					});
					return;
				}

				this.$store.dispatch('dashboard/setCurrentBlock', block._id);
			},
			immediate: true,
		},
	},

	computed: {
		blockId: function () {
			return this.$route.params.blockId;
		},
		folderId: function () {
			return this.$route.params.folderId;
		},
		hasBackground: function () {
			return this.$store.getters['settings/hasBackground'];
		},
		currentBlock: function () {
			let block = null;
			if (this.blockId) {
				block = this.$store.getters['block/block'](this.blockId);
				return block;
			} else {
				block = this.$store.getters['block/rootBlock'];
				return block;
			}
		},
	},

	methods: {},

	mounted: function () {},

	beforeDestroy: function () {},
};
</script>

<style lang="scss">
.c-dashboard {
	position: relative;
	z-index: var(--z-2);
	width: 100%;
	height: 100%;
	overflow-y: auto;

	@include scrollBars();

	&__main {
		position: absolute;
		z-index: var(--z-3);
		top: 0;
		left: 0;
		width: 100%;
		//left: var(--sidebar-width);
		//width: calc(100% - var(--sidebar-width));
		height: 100%;
		overflow-y: auto;
		@include scrollBars();

		&.bg {
			background-color: rgb(6 6 6 / 85%);
		}
	}
}
</style>